import { lowerCase, startCase, capitalize } from "lodash/fp";
/**
 * Function to convert a string to start case ( first letter of each word is capitalized )
 * @param value - the string to be converted to start case
 * @returns start case conversion of the string. eg FOO_BAR will return Foo Bar
 */
export const toStartCase = (value: string) => startCase(lowerCase(value));
export const toCapitalize = (value: string) => capitalize(lowerCase(value));
